<template>
  <div class="payback">
    <Addlog :Type='logType' ref='addlog' v-if='$store.state.Stages.visible'></Addlog>
    <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }"
      class="rform" :class='{ "editbox": $route.params.id }'>
      <a-spin :spinning="loading">
        <div class="cardli">
          <div class="h2">基本信息</div>
          <div class="rboxes">
            <a-row>
              <a-col :span='4'>
                <a-form-model-item label="债务人" prop="name" :label-col="{ span: 24 }" :wrapper-col="{ span: 20 }"
                  style="margin:0;" :rules="{ required: true, message: '请输入要搜索的债务人姓名', trigger: 'blur' }">
                  <a-select show-search v-model="form.name" :disabled="canUse" style="width:90%;" placeholder="请选择债务人"
                    :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                    :not-found-content="null" @search="handleSearch" @change="getcauseList">
                    <a-select-option v-for="d in debtorList" :key="d.id">
                      {{ d.realname }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span='5'>
                <a-form-model-item label="债务人证件号码" style="margin:0;" :label-col="{ span: 24 }" :wrapper-col="{ span: 20 }">
                  <input :value='chinaId' class="input" disabled />
                </a-form-model-item>
              </a-col>
              <a-col :span='3'>
                <a-form-model-item label="所属案件" :label-col="{ span: 24 }" :wrapper-col="{ span: 20 }" style="margin:0;"
                  prop='cause_id' :rules="{ required: true, message: '请选择案件', trigger: 'change' }">
                  <a-select style="width:90%;" placeholder="请选择" v-model='form.cause_id' @change="getStepLists"
                    :disabled="caseIng == 2">
                    <!-- noenforcement_loan(i) ||  -->
                    <a-select-option :key="i.id" v-for='(i, index) in caseList'
                      :disabled="hasCause(i) || noenforcement_loan(i)" v-if="i.invaild == 0">
                      案件 {{ i.sort }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </a-col>
              <a-col :span='5'>
                <a-form-model-item label="当前进度" style="margin:0;" :label-col="{ span: 24 }" :wrapper-col="{ span: 20 }">
                  <input class="input" :value='step' disabled />
                </a-form-model-item>
              </a-col>
              <a-col :span='5'>
                <a-form-model-item label="原告" style="margin:0;" :label-col="{ span: 24 }" :wrapper-col="{ span: 20 }">
                  <input class="input" :value='nowCause.accuser.title' disabled />
                </a-form-model-item>
              </a-col>
              <a-button type="primary" icon='plus' class="subs" v-if='form.cause_id && caseIng == 0'
                @click='addAddCause'>添加分期</a-button>
            </a-row>
          </div>
        </div>
        <div class="cardli" style="padding-bottom:0;" v-if="form.cause_id">
          <div class="h2">关联回款</div>
          <div class="tablelist" v-if="collList.length > 0">
            <table class="table">
              <thead>
                <td>回款日期</td>
                <td>回款小计</td>
                <td>本金</td>
                <td>利息</td>
                <td>诉讼费</td>
                <td>保全费</td>
                <td>公告费</td>
                <td>上诉费</td>
                <td>律师费</td>
                <td>差旅费</td>
                <td>其他</td>
                <td width='140'>操作</td>
              </thead>
              <tbody>
                <tr v-for='(i, index) in collList' :class="{ 'isover': i.cancel == 1 }">
                  <td>{{ i.time | yearFormat }}</td>
                  <td>{{ i.fee | showYuan }}</td>
                  <td>{{ rNumVal(i.fee_list, 8) | showYuan }}</td>
                  <td>{{ rNumVal(i.fee_list, 9) | showYuan }}</td>
                  <td>{{ rNumVal(i.fee_list, 1) | showYuan }}</td>
                  <td>{{ rNumVal(i.fee_list, 3) | showYuan }}</td>
                  <td>{{ rNumVal(i.fee_list, 2) | showYuan }}</td>
                  <td>{{ rNumVal(i.fee_list, 10) | showYuan }}</td>
                  <td>{{ rNumVal(i.fee_list, 4) | showYuan }}</td>
                  <td>{{ rNumVal(i.fee_list, 5) | showYuan }}</td>
                  <td>{{ rNumVal(i.fee_list, 7) | showYuan }}</td>
                  <td>
                    <a href="javascript:void(0);" @click='seeD(i)' v-if='i.comment'>查看备注</a>
                    <span v-else>暂无备注</span>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td><b>总计</b></td>
                  <td v-for="i in collAll">{{ i | showYuan }}</td>
                  <td>-</td>
                </tr>
              </tfoot>
            </table>
          </div>
          <a-empty v-else style="padding:20px 0 40px;" description="暂无关联回款" />
        </div>
        <div class="cardli">
          <div class="h2">分期信息</div>
          <div class="forms">
            <div class="chbox">
              <a href="javascript:void(0);" v-for='(i, index) in usedCase' :key='index' :class='{ "cur": index == useIndex }'
                @click='seeCause(index)'>案件 {{ i.lite.sort }}</a>
            </div>
            <div v-if='caseIng >= 1'>
              <a-row class="clearbox">
                <a-col :span='4'>
                  <a-form-model-item label="期数" :label-col="{ span: 24 }" prop='quantity'
                    :rules="{ required: true, message: '请输入期数', trigger: 'blur' }" class="bjlabel">
                    <a-input-number v-model="form.quantity" :min="1" style="width:180px;" placeholder="请输入期数"
                      :disabled="caseIng == 2" />
                  </a-form-model-item>
                </a-col>
                <a-col :span='4'>
                  <a-form-model-item label="本金" :label-col="{ span: 24 }" prop='capital'
                    :rules="{ required: true, message: '请输入本金', trigger: 'blur' }" class="bjlabel">
                    <a-input-number v-model="form.capital" :min="1" style="width:180px;" placeholder="请输入本金"
                      :class='{ "yellow": capitalAudit }' :disabled="capitalAudit || caseIng == 2" />
                  </a-form-model-item>
                </a-col>
                <a-col :span='4'>
                  <a-form-model-item label="利息" :label-col="{ span: 24 }" prop='used_fee'
                    :rules="{ required: false, message: '请输入利息', trigger: 'blur' }">
                    <a-input-number v-model="form.used_fee" :min="1" style="width:180px;" placeholder="请输入利息"
                      :class='{ "yellow": usedAudit }' :disabled="usedAudit || caseIng == 2" />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-form-model-item label="诉讼相关费用" :label-col="{ span: 3 }" class="lflabel" prop='loan_fee_list'
                :rules="{ required: false, message: '请选择诉讼相关费用', trigger: 'blur' }" v-if='caseIng < 2'>
                <a-button icon="plus" @click='plusAdd(1)'>诉讼费</a-button>
                <a-button icon="plus" @click='plusAdd(2)'>公告费</a-button>
                <a-button icon="plus" @click='plusAdd(3)'>保全费</a-button>
                <a-button icon="plus" @click='plusAdd(4)'>律师费</a-button>
                <a-button icon="plus" @click='plusAdd(5)'>差旅费</a-button>
                <!-- <a-button icon="plus" class="mr20" @click='plusAdd(6)'>退费</a-button> -->
                <a-button icon="plus" @click='plusAdd(10)'>上诉费</a-button>
                <a-button icon="plus" @click='plusAdd(7)'>其他</a-button>
              </a-form-model-item>
              <div class="fourlist">
                <div class="dul" v-if='form.loan_fee_list.length > 0'>
                  <div class="ul">
                    <div v-for='(i, index) in form.loan_fee_list' :key="index" class="dli">
                      <a-form-model-item :label="i.type | CreditName" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }"
                        :prop="'loan_fee_list.' + index + '.fee'"
                        :rules="[{ required: true, message: '请输入', trigger: ['change', 'blur'] },{
                        validator: Validator.priceVal, trigger: ['change', 'blur'] }]">
                        <a-input-number v-model="i.fee" :min="1" style="width:140px;" placeholder="请输入"
                          :class='{ "yellow": i.audit }' :disabled="i.audit || caseIng == 2" />
                      </a-form-model-item>
                      <div class="btns" @click='del(index)' v-if='caseIng < 2'>
                        <a-icon type="minus-circle" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bot">
                  <label>还款总金额：</label>
                  <span> {{ Allpirce | toNum }}</span>
                </div>
                <div class="txtbox">
                  <label>备注</label>
                  <div class="textarea">
                    <textarea v-model='form.comment' maxlength="500" :disabled="caseIng == 2"></textarea>
                    <div class="bot">{{ form.comment.length }}/500</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- v-if='form.cause_id && form.step' -->
            <!-- <a-form-model-item label="添加分期" :label-col="{span: 1}" class="lflabel" :rules="{ required: true, message: '请添加分期',trigger: 'change'}">
              <a-button type='primary' style="margin-left:10px;" @click='postStages(2)'>添加</a-button>
            </a-form-model-item> -->
          </div>
          <!-- <div style="padding:20px 0;">
            <a-empty description='请先选择案件添加' />
          </div> -->
        </div>
        <div class="cardli">
          <div class="h2">
            分期详情 <a-button type='primary' @click='postStages(2)' ghost v-if='caseIng == 1' icon='plus'
              style="float:right;margin-top:12px;">添加分期详情</a-button>
          </div>
          <div class="ltable" v-if='caseIng >= 1'>
            <div class="table">
              <table>
                <thead>
                  <td>当前期数</td>
                  <td>还款日期</td>
                  <td>还款金额</td>
                  <td width='30%'>还款构成</td>
                  <td>操作</td>
                </thead>
                <tbody>
                  <tr v-for='(i, index) in Stages.list' :key='index'>
                    <td>第{{ index + 1 }}期</td>
                    <td>{{ i.time }}</td>
                    <td>{{ i.fee }}</td>
                    <td>
                      <span v-for='(j, ind) in i.list' v-if='j.fee > 0'>
                        {{ j.type | CreditName }} :{{ j.fee }}
                      </span>
                    </td>
                    <td v-if='caseIng < 2'>
                      <a-button type="link" @click='postStages(1, i, index)' style="padding:0;">修改</a-button>
                      <span class="line"></span>
                      <a-popconfirm title="确认删除此条数据吗?" ok-text="确定" cancel-text="取消" @confirm='postDel(index)'>
                        <a-button type="link" style="padding:0;">
                          <font color='#f00'>删除</font>
                        </a-button>
                      </a-popconfirm>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div style="padding:20px 0;" v-else>
            <a-empty description='请先选择案件添加' />
          </div>
        </div>
        <a-form-model-item :wrapper-col="{ span: 24 }" class="elbtns" v-if='caseIng == 1'>
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="confirm">
            <a href='javascript:void(0);' class="oky">
              提交
            </a>
          </a-popconfirm>
          <a-popconfirm title="确认取消此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="cancel">
            <a href='javascript:void(0);' class="cancel">取消</a>
          </a-popconfirm>
        </a-form-model-item>
      </a-spin>
    </a-form-model>
  </div>
</template>
<script>
import Validator from "@/assets/js/yz.js"
import Addlog from "./addlog"
import { mapGetters, mapActions } from 'vuex'
import { causeStep, debtorLists } from '@/server/api'
import stepCredit from './../ly/stepCredit'
import { loanAdd, loanDetails, payList } from '@/server/loan'
export default {
  data() {
    return {
      Validator,
      collAll: [], //关联回款合计
      collList: [],   //关联回款列表
      loading: true,
      capitalAudit: false,
      usedAudit: false,
      rules: {},
      logType: 2,
      debtorList: [],    //债务人列表
      caseList: [],    //案件列表
      useIndex: 0,    //当前分期 索引
      usedCase: [
        {
          over: 0,   //0 初始 1正在修改 2已提交
          lite: {},   //对应案件信息
          form: {}   //对应案件存储信息
        }
      ],
      Case: {},    //当前案件
      nowCause: {
        accuser: {}
      },
      step: '',   //最新进度
      form: {
        step: 0,
        name: "",
        cause_id: null,
        loan_fee_list: [],
        quantity: 1,
        capital: null,
        used_fee: null,
        comment: '',
        period_list: []
      }
    }
  },
  components: {
    Addlog
  },
  created() {
    if (this.$route.params.id > 0) {
      this.init()
    } else {
      this.$store.dispatch('Stages/setInfokey', { key: "list", value: [] })
      this.loading = false;
    }
  },
  filters: {
    CreditName(key) {
      return stepCredit[key * 1]
    },
  },
  computed: {
    ...mapGetters([
      'Stages',
    ]),
    canUse() { //判读是否已添加过分期记录
      return this.usedCase.filter(ele => {
        return ele.over == 2
      }).length > 0
    },
    caseIng() {
      return this.usedCase[this.useIndex].over
    },
    Allpirce() {
      let newArr = this.form.loan_fee_list.map(ele => {
        return ele.fee ? ele.fee : 0
      })
      newArr.push(this.form.capital)
      newArr.push(this.form.used_fee)
      return newArr.reduce((a, b) => {
        return a + b
      })
    },
    chinaId() {
      if (this.debtorList.length > 0 && this.form.name) {
        const list = this.debtorList.filter(ele => { return ele.id === this.form.name })
        if (list.length > 0) {
          return list[0].chinaid
        }
      }
    }
  },
  methods: {
    seeD(item) {
      this.$modal.info({
        title: '备注',
        footer: null,
        content: item.comment,
      });
    },
    getCollList(id) {   //计算合计
      payList({ cause_id: id }).then(e => {
        this.collList = e ? e.list : []
        const getAll = (type) => {
          let i = 0;
          e.list.map(ele => {
            ele.fee_list.map(s => {
              if (s.type == type) {
                i += s.fee
              }
            })
          })
          return i
        }
        const getFee = () => {    //合计
          let i = 0;
          e.list.map(ele => {
            i += ele.fee
          })
          return i
        }
        let all = [8, 9, 1, 3, 2, 10, 4, 5, 7].map(ele => {
          return getAll(ele)
        })
        all.unshift(getFee())
        this.collAll = all
      })
    },
    rNumVal(fee_list, t) {
      if (fee_list) {
        let fee = fee_list.filter(ele => { return ele.type == t })
        if (fee.length > 0) {
          return fee[0].fee
        } else {
          return 0
        }
      }
    },
    seeCause(index) {
      const usedCase = JSON.parse(JSON.stringify(this.usedCase))
      const nowOver = usedCase[this.useIndex]       //当前 焦点节点 index是当前点击
      if (usedCase.length <= 1) return false;
      if (usedCase[index].over == 0) {
        this.form.cause_id = null
        this.useIndex = index;
        return false;
      }
      if (nowOver.over == 1 && usedCase[index].over == 2) {        //保存数据
        usedCase[this.useIndex].form = this.form
        this.usedCase = usedCase
      }

      this.getCollList(nowOver.lite.id)
      this.form = usedCase[index].form;
      this.$store.dispatch('Stages/setInfokey', { key: 'list', value: usedCase[index].form.period_list })
      this.useIndex = index;
    },
    hasCause(e) {     //静态新增的案件记录 过滤
      return this.usedCase.filter(ele => { return ele.over == 2 && ele.lite.id == e.id }).length > 0
    },
    noenforcement_loan(e) {   //已新增的历史案件记录 过滤
      return e.no_enforcement_loan.filter(ele => { return ele.cause_id == e.id }).length > 0
    },
    async init() {  //初始化
      loanDetails({ debtor_id: this.$route.params.id }).then(res => {
        debtorLists({ chinaid: res.info.chinaid }).then(e => {
          this.debtorList = e.list
          this.getcauseList(res.info.id)
        })
        this.form.name = res.info.id
        this.loading = false;
      })
    },
    addAddCause() {  //新增分期
      let index = this.useIndex
      this.usedCase[index].over = 1;
      this.usedCase[index].lite = this.nowCause
    },
    async getcauseList(id) {        //获取案件
      this.caseList = []
      this.form.cause_id = null
      this.form.step = 0;
      this.step = null
      if (this.debtorList.length > 0) {
        let Arr = this.debtorList.filter(ele => {
          return ele.id == id
        })
        this.caseList = Arr.length > 0 ? Arr[0].cause : []
        this.Case = Arr.length > 0 ? Arr[0] : {}
        this.usedCase[this.useIndex].over = 0
      }
    },
    async getStepLists(cause_id) {      //获取进度
      let nowCase = this.caseList.find(ele => {
        return ele.id == cause_id
      })
      this.getCollList(cause_id)
      this.nowCause = nowCase
      causeStep({ cause_id: cause_id }).then(e => {
        const step = e.list.length > 0 ? e.list[e.list.length - 1] : "暂无进度"
        this.step = e.list.length > 0 ? step.title : step;
        this.form.step = e.list.length > 0 ? step.step : 0
        this.usedCase[this.useIndex].over = 0
        this.usedCase[this.useIndex].form = {}
        this.form.quantity = 1
        this.form.capital = null
        this.form.used_fee = null
        this.form.comment = ''
        this.form.loan_fee_list = []
        this.$store.dispatch('Stages/setInfokey', { key: 'list', value: [] })
      })
    },
    async handleSearch(name) {
      if (name) {
        debtorLists({ realname: name }).then(e => {
          this.debtorList = e.list
        })
      } else {
        this.form.name = ''
        this.debtorList = []
      }
    },
    confirm() {
      this.$refs.forms.validate(valid => {
        if (valid) {
          let form = JSON.parse(JSON.stringify(this.form));
          form.period_list = JSON.parse(JSON.stringify(this.$store.state.Stages.list))
          if (form.period_list.length == 0) {
            this.$message.error({ content: '请添加分期', key: 'updatable' });
            return false;
          }
          form.period_list.map(ele => {
            ele.fee = ele.fee * 100
            ele.list.map(element => {
              element.fee = element.fee * 100
            })
          })
          if (form.period_list.length != form.quantity * 1) {
            this.$message.error("录入的期数与添加分期的数量需要一致")
            return false;
          }

          form.loan_fee_list = form.loan_fee_list.concat([{
            fee: form.capital,
            id: 0,
            type: 8
          }, {
            fee: form.used_fee,
            id: 0,
            type: 9
          }]).filter(ele => {
            return ele.fee > 0
          })
          delete form.capital
          delete form.used_fee
          form.loan_fee_list.map(ele => {
            ele.fee = ele.fee * 100
          })
          let perfee = form.period_list.map(ele => {
            return ele.fee * 1
          }).reduce((prev, next) => {
            return prev + next
          })
          let loanfee = form.loan_fee_list.map(ele => {
            return ele.fee * 1
          }).reduce((prev, next) => {
            return prev + next
          })
          perfee = perfee.toFixed(2)
          loanfee = loanfee.toFixed(2)
          if (perfee != loanfee) {
            this.$message.error("分期总额与子分期的总和需保持一致")
            return false;
          }


          loanAdd(form).then(e => {
            this.$message.success({ content: '新增成功', key: 'updatable' });
            this.reset()
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancel() {
      const usedCase = JSON.parse(JSON.stringify(this.usedCase))
      usedCase[this.useIndex].over = 0;
      this.usedCase = usedCase
      this.form.capital = null
      this.form.used_fee = null
      this.form.comment = ''
      this.form.loan_fee_list = []
      this.$store.dispatch('Stages/setInfokey', { key: 'list', value: [] })
    },
    reset() {
      let usedCase = JSON.parse(JSON.stringify(this.usedCase))
      usedCase[this.useIndex].over = 2;   //把当前设置为已完成
      usedCase[this.useIndex].form = JSON.parse(JSON.stringify(this.form))
      usedCase[this.useIndex].form.period_list = JSON.parse(JSON.stringify(this.$store.state.Stages.list))
      this.useIndex = this.useIndex + 1
      usedCase.push({
        over: 0,   //0 初始 1正在修改 2已提交
        lite: {},   //对应案件信息
        form: []   //对应案件存储信息
      })
      this.form.quantity = 1
      this.form.cause_id = null;
      this.form.capital = null
      this.form.used_fee = null
      this.form.comment = ''
      this.form.loan_fee_list = []
      this.usedCase = usedCase
      this.$store.dispatch('Stages/setInfokey', { key: 'list', value: [] })
      //  this.$router.replace({ "name": "payback" })
    },
    async postStages(type, item, index) {   //添加分期 
      this.logType = type;
      if (type == 1) {
        await this.$store.dispatch('Stages/setInfokey', { key: 'curIndex', value: index })
        await this.$store.dispatch('Stages/setInfokey', { key: 'cur', value: item })
      }
      await this.$store.dispatch('Stages/setInfokey', { key: 'visible', value: true })
    },
    postDel(index) {   //删除表单
      this.$store.dispatch('Stages/reMove', index)
    },
    del(index) {
      this.form.loan_fee_list.splice(index, 1)
    },
    plusAdd(type) {
      this.form.loan_fee_list.push({
        type: type,
        fee: null,
        id: 0
      })
    }
  },
}
</script>
<style lang="less">
.payback {
  .lflabel {
    margin-bottom: 10px;

    .ant-form-item-label {
      text-align: left;
      width: 100px;
    }

    .ant-btn {
      padding: 0 6px;
      width: 84px;
      height: 28px;
      margin-right: 10px;
      color: #a2a3a5;
      font-size: 14px;

      span {
        margin-left: 4px;
      }
    }

    .ant-btn:hover,
    .ant-btn:focus {
      color: #1e8bfe;
      background-color: #fff;
      border-color: #1e8bfe;
    }
  }

  .rform {
    .ul {
      .ant-form-item-label {
        width: 60px;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.cardli {
  background: #fff;
  margin-bottom: 10px;
  padding-bottom: 20px;

  .h2 {
    font-size: 16px;
    font-weight: 500;
    color: #0e2949;
    line-height: 62px;
    padding: 0 20px;
    font-weight: bold;
    border-bottom: 1px solid #efefef;
  }

  .dul {
    padding-top: 20px;
    background: #f3f6fb;
    border-radius: 4px;
    margin-bottom: 10px;
    padding-bottom: 10px;

    .ul {
      overflow: hidden;
      display: flex;
      flex-wrap: wrap;
    }

    .dli {
      padding-left: 30px;
      width: 25%;
      display: flex;
      margin-bottom: 10px;
      align-items: center;
      height: 60px;
      // overflow: hidden;

      .ant-form-item {
        margin: 0;
      }

      .btns {
        margin-left: 20px;
        color: #f00;
        cursor: pointer;
      }
    }
  }

  .mr20 {
    margin-right: 20px;
  }

  .rboxes {
    padding: 18px 20px 0;

    label {
      display: block;
      font-size: 14px;
      font-weight: 500;
      color: #0e2949;
      line-height: 17px;
      margin-bottom: 6px;
    }

    .input {
      width: 100%;
      background-color: #fff;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      padding: 0 11px;
      line-height: 32px;
      background: #f7f7f7;
    }

    .subs {
      margin-top: 32px;
      width: 117px;
      height: 34px;
      background: #1d8bfe;
      border-radius: 4px;
    }
  }

  .forms {
    padding: 0 20px;

    .chbox {
      margin-bottom: 14px;
      border-bottom: 1px solid #efefef;
      line-height: 50px;

      a {
        color: #333;
        font-size: 14px;
        font-weight: 500;
        margin-right: 20px;
        transition-duration: 500ms;
      }

      a:hover,
      .cur {
        color: #1d8bfe;
      }
    }

    .clearbox {
      /deep/ .ant-form-item {
        margin-bottom: 10px;
      }
    }
  }

  .fourlist {
    margin-bottom: 20px;

    .bot {
      font-size: 14px;
      color: #0e2949;
      line-height: 20px;
    }

    .txtbox {
      margin-top: 20px;

      label {
        font-size: 14px;
        color: #0e2949;
      }

      .textarea {
        width: 572px;
        height: 132px;
        border-radius: 4px;
        border: 1px solid #dbdcde;
        padding: 10px;
        margin-top: 10px;

        textarea {
          width: 100%;
          height: 84px;
          border: 0 none;
        }

        .bot {
          text-align: right;
          font-size: 14px;
          color: rgba(162, 163, 165, 0.5);
          line-height: 20px;
        }
      }
    }
  }

  .ltable {
    padding: 20px;
  }
}

.rows {
  padding: 20px 20px 0 20px;
  font-size: 14px;
  color: #0e2949;
  line-height: 20px;

  span {
    color: #66707c;
  }
}

.tablelist {
  padding: 20px 20px 0;

  tbody {
    td {
      height: 58px;
      color: #66707c;
    }

    tr {
      border-top: 0 none;
      border-bottom: 1px solid #efefef;
    }
  }

  tfoot {
    td {
      height: 64px;
      font-size: 14px;
      font-weight: bold;
      color: #0e2949;
    }
  }
}

.elbtns {
  padding-top: 20px;

  a {
    display: inline-block;
    width: 80px;
    line-height: 36px;
    background: #1d8bfe;
    border-radius: 4px;
    text-align: center;
    margin-right: 20px;
    color: #fff;
  }

  .cancel {
    background: #b2c9e1;
  }
}
</style>